import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  EmployerContactFormSchema,
  type EmployerContactFormValues,
} from '@duke-hq/svc-api/admin/trpc/routers/workPlacements/employers/schemas';
import { EmployerContactFields } from '../EmployerContactFields';

export type NewContactFormHandle = { validate: () => Promise<boolean> };

export const NewContactForm = forwardRef<
  NewContactFormHandle,
  {
    value: EmployerContactFormValues;
    onChange: (value: EmployerContactFormValues) => void;
  }
>(function NewContactForm({ value, onChange }, ref) {
  const methods = useForm<EmployerContactFormValues>({
    resolver: zodResolver(EmployerContactFormSchema),
    reValidateMode: 'onSubmit',
    defaultValues: value,
  });

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useImperativeHandle(ref, () => ({ validate: () => methods.trigger() }), [methods]);

  const watched = useWatch({ control: methods.control });

  useEffect(() => {
    onChangeRef.current(methods.getValues());
  }, [watched, methods]);

  return (
    <FormProvider {...methods}>
      <EmployerContactFields requireName showPrimaryToggle />
    </FormProvider>
  );
});
